async function setupRegionPersonalization() {
  const config = window.intelligemsSettings;
  const apiKey = config?.ip_stack_api_key;

  const targetRegions = [
    config?.geo_region_1,
    config?.geo_region_2,
    config?.geo_region_3
  ];

  if (!apiKey) return;

  try {
    const response = await fetch(`https://api.ipstack.com/check?access_key=${apiKey}`);
    const data = await response.json();

    const userRegion = data.region_name;
    const userCountry = data.country_code;

    targetRegions.forEach((regionName, index) => {
      const variableName = `isRegion${index + 1}User`;
      
      if (regionName && userRegion === regionName && userCountry === 'AU') {
        window[variableName] = true;
      } else {
        window[variableName] = false;
      }
    });

  } catch (error) {
    console.error('Error identifying region:', error);
    // Fallback para evitar variáveis undefined
    window.isRegion1User = false;
    window.isRegion2User = false;
    window.isRegion3User = false;
  }
}

setupRegionPersonalization();